// src/components/common/Button/Button.js
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './Button.css';

const Button = ({
                    children,
                    variant = 'primary',
                    size = 'medium',
                    href,
                    to,
                    type = 'button',
                    disabled = false,
                    fullWidth = false,
                    icon,
                    iconPosition = 'right',
                    onClick,
                    className = '',
                    ...props
                }) => {
    const buttonClasses = `
        btn 
        btn-${variant} 
        btn-${size}
        ${fullWidth ? 'btn-full-width' : ''}
        ${disabled ? 'btn-disabled' : ''}
        ${className}
    `.trim();

    const content = (
        <>
            {icon && iconPosition === 'left' && (
                <span className="btn-icon btn-icon-left">{icon}</span>
            )}
            {children}
            {icon && iconPosition === 'right' && (
                <span className="btn-icon btn-icon-right">{icon}</span>
            )}
        </>
    );

    if (to) {
        return (
            <Link to={to} className={buttonClasses} onClick={onClick} {...props}>
                {content}
            </Link>
        );
    }

    if (href) {
        return (
            <a href={href} className={buttonClasses} onClick={onClick} {...props}>
                {content}
            </a>
        );
    }

    return (
        <button
            type={type}
            className={buttonClasses}
            disabled={disabled}
            onClick={onClick}
            {...props}
        >
            {content}
        </button>
    );
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(['primary', 'secondary', 'accent', 'outline', 'text']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    href: PropTypes.string,
    to: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    icon: PropTypes.node,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    onClick: PropTypes.func,
    className: PropTypes.string,
};

export default Button;